import React from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import { EasyDrawStore, EasyDrawContext } from '../../store';
import AppRoutes from './AppRoutes';
import '../../i18n'
import '../font.sg.less'
import '../../styles/tailwind.css'
import 'antd/dist/reset.css'
import '../../styles/global.less'
import '@shared/theme/canvopix-theme.less'

const App = () => (
  <BrowserRouter>
    <AppRoutes />
  </BrowserRouter>
)

const store = new EasyDrawStore()
// console.log('===', store)
// @ts-ignore
// window.__store__ = store
const root = createRoot(document.getElementById('root'))
root.render(
  <EasyDrawContext.Provider value={store}>
    <App />
  </EasyDrawContext.Provider>
)
